import { useEffect, useState } from "react";

const ideas = {
  real: [
    "Build an Instagram clone interface",
    "Invoice page for e-commerce store",
    "User sign up form with validation",
    "Real-time chat application UI",
    "Project management dashboard design",
    "Health tracking app for patients",
    "E-learning platform course interface",
    "Financial budgeting app layout",
    "Social media dashboard analytics",
    "Customer feedback collection form",
    "Event booking system interface",
    "Travel itinerary planner app",
    "Restaurant reservation system UI",
    "Job recruitment portal design",
    "News aggregator app interface",
    "Weather forecasting app design",
    "Car rental booking interface",
    "Fitness workout planner UI",
    "Recipe sharing platform design",
    "Email marketing tool dashboard",
  ],
  long: [
    "Interactive 3D product viewer for e-commerce",
    "AI chatbot interface for customer support",
    "Customizable dashboard widgets for analytics",
    "Multi-level navigation menu with animations",
    "Dynamic data table with sorting and filtering",
    "Collapsible accordion FAQ section",
    "Personalized content recommendation engine",
    "Real-time collaborative document editor",
    "Advanced search bar with filters and suggestions",
    "User-generated content moderation dashboard",
    "Event timeline with interactive milestones",
    "Drag-and-drop interface for task management",
    "Interactive financial chart and analysis tools",
    "Custom video player with annotations",
    "Voice activated commands for accessibility",
    "Themeable UI components for branding",
    "Multi-language support toggle",
    "Date range picker for report generation",
    "User profile completion progress bar",
    "Live polling and survey tool",
  ],
  short: [
    "Modal login form",
    "Dynamic breadcrumbs",
    "Responsive side navigation",
    "Floating action button",
    "Accordion dropdown",
    "Circular progress indicator",
    "Customizable data charts",
    "Thumbnail image gallery",
    "Swipeable content cards",
    "Animated alert notifications",
    "Tabbed content panels",
    "Searchable dropdown list",
    "Step wizard for onboarding",
    "Toggle switch button",
    "Tooltip hover information",
    "Avatar with status indicator",
    "Breadcrumb navigation",
    "Collapsible sidebar menu",
    "Tag input for categories",
    "Rating system with stars",
  ],
  fun: [
    "Interactive galaxy map for space exploration",
    "Fantasy football team draft kit",
    "Virtual fashion show runway",
    "Interactive cooking challenge timer",
    "Garden pest identifier and tracker",
    "DIY project idea generator",
    "Music festival lineup builder",
    "Virtual escape room puzzle components",
    "Pet photo contest voting system",
    "Mystery novel plot generator",
    "Comic book style chat bubbles",
    "Animated weather effects display",
    "Historical figure trivia game",
    "Animated recipe preparation steps",
    "Horror movie survival guide",
    "Interactive constellation map",
    "Virtual museum exhibit tour",
    "Zombie apocalypse survival planner",
    "Pirate ship battle game interface",
    "Magical spellbook browser",
  ],
};

export const useSuggestions = () => {
  const [suggestions, setSuggestions] = useState({});

  const refreshSuggestions = () => {
    const selected = {};
    // Get all categories and shuffle them
    const categories = Object.keys(ideas);
    const shuffledCategories = categories.sort(() => Math.random() - 0.5);
    // Take only first 3 categories
    const selectedCategories = shuffledCategories.slice(0, 3);

    selectedCategories.forEach((category) => {
      const categoryIdeas = ideas[category];
      const randomIndex = Math.floor(Math.random() * categoryIdeas.length);
      selected[category] = categoryIdeas[randomIndex];
    });
    setSuggestions(selected);
  };

  useEffect(() => {
    refreshSuggestions();
  }, []);

  return { suggestions, refreshSuggestions };
};
